/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BanStatus } from '../../models/ban-status';
import { UserAdminResponsePaging } from '../../models/user-admin-response-paging';

export interface GetUserAdmins$Params {
  banStatus: BanStatus;
  page: number;
  pageSize: number;
  orderBy?: string;
  filter?: string;
}

export function getUserAdmins(http: HttpClient, rootUrl: string, params: GetUserAdmins$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAdminResponsePaging>> {
  const rb = new RequestBuilder(rootUrl, getUserAdmins.PATH, 'get');
  if (params) {
    rb.query('banStatus', params.banStatus, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('filter', params.filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserAdminResponsePaging>;
    })
  );
}

getUserAdmins.PATH = '/api/editorial/user-admins';
